/* ====================================================================
   FLOOREVER — MODULE PANIER COMMUN (window.FloorEverCart)
   Vanilla JS, chargé en defer par layout/theme.liquid AVANT les scripts
   de sections (ordre du document) — audit 10/07/2026, action T4 :
   la pastille header était réécrite dans 6 fichiers avec des variantes
   divergentes et detail.source n'était posé que par 2 émetteurs sur 6.

   CONTRAT COMMUN DU THÈME :
   - après toute mutation du panier, l'émetteur appelle
     FloorEverCart.rafraichir(routePanierJs, source) : relit /cart.js,
     met à jour la pastille (.cart-link .cart-count, créée si absente),
     puis émet document -> CustomEvent 'floorever:cart:change' avec
     detail.cart (payload /cart.js) et detail.source ;
   - sources normalisées : 'fiche' (bloc d'achat + échantillon PDP),
     'carte' (échantillon depuis les cartes), 'echantillon' (page
     échantillon), 'complements' (ajout rapide accessoires), 'panier'
     (page panier), 'drawer' (mini-panier) ;
   - le drawer n'ouvre AUTOMATIQUEMENT que sur un ajout (compteur qui
     augmente) et JAMAIS pour les sources 'panier' et 'drawer' ;
   - un échantillon par décor : FloorEverCart.gratuits(panier) donne
     les lignes gratuites avec la réf. décor FExxx de chacune, et
     FloorEverCart.refDecor(sku, titre) la réf. d'un SKU ou d'un titre.
     Règle unique des cartes, de la fiche et de la page échantillon,
     ticket 3 de la recette.

   Chaque script de section garde un repli minimal si ce module manque
   (progressive enhancement : rien ne casse, la pastille est juste
   moins précise, et un doublon de décor n'est reconnu que sur la même
   variante).
   ==================================================================== */
(function () {
  'use strict';
  if (window.FloorEverCart) return;

  function pluriel(n) {
    return n === 0 ? 'Panier vide' : 'Panier, ' + n + ' article' + (n > 1 ? 's' : '');
  }

  /* Pastille du header : créée si absente, retirée à 0. */
  function majPastille(compte) {
    var n = parseInt(compte, 10) || 0;
    document.querySelectorAll('.cart-link').forEach(function (lien) {
      var pastille = lien.querySelector('.cart-count');
      if (!pastille && n > 0) {
        pastille = document.createElement('span');
        pastille.className = 'cart-count';
        pastille.setAttribute('aria-hidden', 'true');
        lien.appendChild(pastille);
      }
      if (pastille) {
        if (n > 0) pastille.textContent = n;
        else pastille.remove();
      }
      lien.setAttribute('aria-label', pluriel(n));
    });
    /* Lien « Panier · N » du menu mobile (sans parenthèses, 16/10/2026). */
    document.querySelectorAll('[data-cart-burger]').forEach(function (l) {
      l.textContent = n > 0 ? 'Panier · ' + n : 'Panier';
    });
  }

  function notifier(panier, source) {
    document.dispatchEvent(
      new CustomEvent('floorever:cart:change', {
        detail: { cart: panier, source: source || 'inconnu' }
      })
    );
  }

  /* Lecture du panier (route /cart.js — le suffixe est ajouté s'il manque). */
  function lire(routePanier) {
    var route = routePanier || '/cart.js';
    if (route.slice(-3) !== '.js') route += '.js';
    return fetch(route, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('lecture panier impossible (' + r.status + ')');
      return r.json();
    });
  }

  /* Relecture + pastille + événement. Ne rejette jamais (silencieux). */
  function rafraichir(routePanier, source) {
    return lire(routePanier)
      .then(function (panier) {
        majPastille(panier.item_count);
        notifier(panier, source);
        return panier;
      })
      .catch(function () { return null; });
  }

  /* Réf. décor FExxx : identifiant du décor commun à toutes ses gammes.
     SKU : FE + 2 lettres de gamme + 2 chiffres + 3 chiffres du décor,
     FECH55308-ECH -> FE308, FEGH30111S -> FE111. Titre : premier mot,
     « FE308 Chêne tradition » -> FE308, même règle que card-produit.
     Chaîne vide si aucune réf. n'est trouvée. */
  var REF_SKU = /^FE[A-Z]{2}\d{2}(\d{3})/i;
  var REF_TITRE = /^(FE\d{3})\b/i;

  function refDecor(sku, titre) {
    var m = REF_SKU.exec(String(sku || '').trim());
    if (m) return 'FE' + m[1];
    m = REF_TITRE.exec(String(titre || '').trim());
    return m ? m[1].toUpperCase() : '';
  }

  /* Échantillons = lignes gratuites (final_price 0) : quantité totale,
     ids de variantes et réf. décor (refs, sans doublon) — même détection
     sur toutes les surfaces. La réf. reconnaît un décor quelle que soit
     la gamme de son échantillon au panier. */
  function gratuits(panier) {
    var total = 0;
    var ids = [];
    var refs = [];
    ((panier && panier.items) || []).forEach(function (item) {
      if (item.final_price === 0 || item.price === 0) {
        total += item.quantity;
        ids.push(item.variant_id);
        var ref = refDecor(item.sku, item.product_title);
        if (ref && refs.indexOf(ref) === -1) refs.push(ref);
      }
    });
    return { total: total, ids: ids, refs: refs };
  }

  window.FloorEverCart = {
    majPastille: majPastille,
    notifier: notifier,
    lire: lire,
    rafraichir: rafraichir,
    gratuits: gratuits,
    refDecor: refDecor
  };
})();
